// extracted by mini-css-extract-plugin
export default {"particles":"BlackParticles_particles__WcVvy","particle":"BlackParticles_particle__H6bto","floatParticle":"BlackParticles_floatParticle__8xDm8"};